export { default as Legend } from './Legend'

export const COLORS = [
  'var(--chakra-colors-brand-primary-dark_2)',
  'var(--chakra-colors-brand-highlight-dark)',
  'var(--chakra-colors-brand-highlight-base)',
  'var(--chakra-colors-brand-primary-dark_1)',
  'var(--chakra-colors-brand-highlight-light)',
]
